module.exports = __webpack_public_path__ + "img/invoice-run.f2b9f45b.svg";